<template>
  <v-dialog v-model="active" persistent max-width="600px">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Filter Assets</span>
      </v-card-title>
      <v-card-text>
        <!-- <mission-autocomplete :value.sync="filters.mission" /> -->
        <!-- Needs to be developed to list `asset_types` defined in contract->config
        <v-select
          item-text="name"
          item-value="id"
          :items="[{ id: 180, name: 'CATCHPIT' }]"
          label="Type"
          :value="180"
        />
        -->
         <v-select
          item-text="text"
          item-value="value"
          v-model="filters.region"
          :items="filterRegionOptions"
          label="Region"
          clearable
          dense
        />
        <v-menu
          v-model="menus.dateStart"
          :close-on-content-click="false"
          :return-value.sync="filters.dateStart"
          transition="fade-transition"
          offset-y
          min-width="290px"
          ref="menudateStart"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              clearable
              label="Service Date - Start"
              readonly
              :value="filters.dateStart | dateLocal('DD-MMM-YYYY', '')"
              v-on="on"
              @click:clear="filters.dateStart = ''"
            />
          </template>
          <v-date-picker v-model="filters.dateStart" @input="$refs.menudateStart.save(filters.dateStart)" no-title scrollable></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menus.dateEnd"
          :close-on-content-click="false"
          :return-value.sync="filters.dateEnd"
          transition="fade-transition"
          offset-y
          min-width="290px"
          ref="menudateEnd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              clearable
              label="Service Date - End"
              readonly
              :value="filters.dateEnd | dateLocal('DD-MMM-YYYY', '')"
              v-on="on"
              @click:clear="filters.dateEnd = ''"
            />
          </template>
          <v-date-picker v-model="filters.dateEnd" @input="$refs.menudateEnd.save(filters.dateEnd)" no-title scrollable></v-date-picker>
        </v-menu>
        <v-text-field
          clearable
          label="Text/Number"
          v-model="filters.assets_search"
          @click:clear="filters.assets_search = ''"
        />
        <v-radio-group v-model="filters.serviceType">
          <v-radio
            :label="'Requires ' + (getTerminology('service') || 'Service') + ' Soon'"
            :value="$options.serviceTypes.requiresServiceSoon"
          />
          <v-radio
            :label="(getTerminology('service') || 'Service') + ' Overdue'"
            :value="$options.serviceTypes.serviceOverdue"
          />
        </v-radio-group>
        <v-checkbox
          v-model="filters.serviceSuccessful"
          :label="(getTerminology('service') || 'Service') + ' Successful'"
        />
        <v-checkbox
          v-model="filters.serviceFailed"
          :label="(getTerminology('service') || 'Service') + ' ' + (getTerminology('failed') || 'Failed')"
          class="mt-n4"
        />
        <v-card outlined class="mt-n4 pa-2">
          <div class="text-overline ml-1">Faults</div>
          <v-checkbox
            hide-details
            v-model="filters.faults"
            value="none"
            label="None"
            class="mt-1 pt-0"
          />
          <v-checkbox
            hide-details
            v-model="filters.faults"
            value="resolved"
            label="Resolved"
            class="mt-1"
          />
          <v-checkbox
            hide-details
            v-model="filters.faults"
            value="unresolved"
            label="Unresolved"
            class="mt-1"
          />
        </v-card>
        <v-checkbox
          v-model="filters.newAsset"
          label="New Asset"
          class="mt-1"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">CANCEL</v-btn>
        <v-btn text @click="reset">RESET</v-btn>
        <v-btn text @click="filter">FILTER</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from "@/store";
import moment from "moment";
import { mapGetters } from "vuex";
import { formatDateLocal } from "@/helpers/dates";
import { ContractService } from "@/services/contract.service";
import MissionAutocomplete from "@/components/Mission/MissionAutocomplete";

const getDefaultFilters = function() {
  // Reminder: these filters are shared between missions and mission_assets
  // and get submitted to missions, mission_assets and metric endpoints.
  // (though naming may need a mapping when used as query parameters)
  // @todo - centralise (duplicate found in the MissionTableFilter)
  return {
    // Missions
    number: "", // ID in a LIKE sense?
    reference: "", // The third_party_code
    status: "",
    inspectedBy: undefined,
    data: {},
    includeArchived: 0,
    locked: null,
    claimed: null,
    // MissionAssets
    mission: "", // A specific ID?
    assets_search: "", // Free text, mostly third_party_code
    serviceType: "", // serviceOverdue etc.
    serviceSuccessful: true,
    serviceFailed: true,
    faults: ['none', 'resolved', 'unresolved'],
    newAsset: undefined,
    // Overlap - some filters may be editable on missions or mission_assets pages
    dateStart: moment().subtract(12, 'month').startOf('month').toISOString(true),
    dateEnd: moment().endOf('day').toISOString(true),
    region: "", // mission region
  };
};

const getStoredFilters = function() {
  return (Object.keys(store.state.filters.missions).length > 0)
    ? store.state.filters.missions
    : null;
};

export default {
  serviceTypes: {
    requiresServiceSoon: "requiresServiceSoon",
    serviceOverdue: "serviceOverdue",
  },
  components: {
    // MissionAutocomplete
  },
  data: () => ({
    active: false,
    filters: getDefaultFilters(),
    filtersDefault: getDefaultFilters(),
    menus: {
      dateStart: false,
      dateEnd: false,
    },
  }),
  computed: {
    ...mapGetters("config", ["getTerminology"]),
    filterRegionOptions() {
      let options = [];
      const mission_custom_fields = this.$store.getters['config/getConfigByKey']('mission_custom_fields') || [];
      const regionQuestion = mission_custom_fields.find(q => {
        return (q.code.toLowerCase() == 'region');
      });
      if (regionQuestion && Array.isArray(regionQuestion.options)) {
        regionQuestion.options.forEach(region_letter => {
          options.push({
            text: region_letter,
            value: region_letter,
          });
        });
      }
      return options;
    }
  },
  watch: {
    "filters.serviceType"(value) {
      if (value === this.$options.serviceTypes.requiresServiceSoon) {
        this.filters.dateStart = moment()
          .subtract(5, "months")
          .format("YYYY-MM-DD");
        this.filters.dateEnd = moment()
          .add(2, "months")
          .format("YYYY-MM-DD");
      } else if (value === this.$options.serviceTypes.serviceOverdue) {
        this.filters.dateStart = "";
        this.filters.dateEnd = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
      }
    },
    "$store.state.filters.missions": function() {
      this.$data.filters = getStoredFilters() || getDefaultFilters();
      this.$emit('filter', Object.assign({}, this.$data.filters));
    },
    "filters.faults"(value) {
      // Unchecking all the boxes would either force no results
      // (largely pointless) or be the same as checking all.
      // (we restore default if all checkboxes unchecked)
      if (Array.isArray(value) && value.length == 0) {
        const default_filters = getDefaultFilters();
        this.$nextTick(function () {
          this.$set(this.$data.filters, 'faults', default_filters.faults);
        });
      }
    },
  },
  mounted() {
    this.$store.commit("startLoading");
    this.prepareFiltersAsync().then(filters => {
      this.filter();
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => {
      this.$store.commit("endLoading");
    });
  },
  methods: {
    prepareFiltersAsync() {
      return new Promise((resolve, reject) => {
        const filtersStored = getStoredFilters();
        let filtersDefault = getDefaultFilters();
        let filters = getStoredFilters() || getDefaultFilters();
        let contract_id = this.$store.state.auth.user.contract_id;
        ContractService.assessmentPeriod(contract_id).then(response => {
          const assessmentPeriod = response.data;
          if ( ! filtersStored) {
            filters.dateEnd = assessmentPeriod.assessment_period_end || filters.dateEnd;
            filters.dateStart = assessmentPeriod.assessment_period_start || filters.dateStart;
          }
          // The component always needs sensible defaults to reset to and in
          // the case of the date range, this comes from assessment period)
          filtersDefault.dateEnd = assessmentPeriod.assessment_period_end || filtersDefault.dateEnd
          filtersDefault.dateStart = assessmentPeriod.assessment_period_start || filtersDefault.dateStart
          this.$store.dispatch('filters/setMissionsAssessmentPeriod', assessmentPeriod);
          this.$store.dispatch('filters/setDefaultMissionsFilters', filtersDefault);
          this.filtersDefault = filtersDefault;
          this.filters = filters;
          resolve(filters);
        })
        .catch(err => {
          reject(err);
        });
      });
    },
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
    reset() {
      // Reminder, user still needs to click Filter after clicking reset to confirm
      this.filters = Object.assign({}, this.filtersDefault);
    },
    copyFiltersToStore() {
      // Store the filters in vuex for shared use by metrics and missions index
      this.$store.dispatch('filters/setMissionsFilters', Object.assign({}, this.filters));
    },
    filter(options) {
      // Reminder: we have a watcher that watches the
      // filters in the store and then emits them.
      this.copyFiltersToStore();
      this.close();
    },
  },
};
</script>
